module.exports = __webpack_public_path__ + "static/media/comienzo_de_una_nueva_era.19d2748e.md";